<template>
    <div class="container">
        <div class="row mt-5">
            <div class="col-12 text-center">
                <h1>Expertise</h1>
                <hr class="header-underline">
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-12 mt-3">
                <h4>
                    Results-driven and motivated Software Engineer with a demonstrated history in creating and 
                    executing software solutions. Experienced in all aspects of the software development lifecycle.
                </h4>

                <h4>
                    Strong engineering professional with a Bachelor’s of Science Degree focused in Computer Software 
                    Engineering from Johnson & Wales University. Skilled in Embedded System Software Development, 
                    Web applications, Database and API Design. 
                </h4>
                
                <h4>
                    I am constantly seeking challenging opportunities that will allow me to enhance my career in the world of Software & Technology.
                </h4>
            </div>

        </div>
        <div class="row mt-5">
            <div class="col-lg-6">
                <div data-aos="fade-up" data-aos-duration="1500">
                    <div class="row mt-2">
                        <div class="col-lg-4 text-right">
                            <h3>NodeJS</h3>
                        </div>
                        <div class="col-lg-6">
                            <div class="progress mt-2">
                                <div class="progress-bar blue-background" role="progressbar" style="width: 90%" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-lg-4 text-right">
                            <h3>PHP</h3>
                        </div>
                        <div class="col-lg-6">
                            <div class="progress mt-2">
                                <div class="progress-bar blue-background" role="progressbar" style="width: 80%" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-lg-4 text-right">
                            <h3>MySQL</h3>
                        </div>
                        <div class="col-lg-6">
                            <div class="progress mt-2">
                                <div class="progress-bar blue-background" role="progressbar" style="width: 90%" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-lg-4 text-right">
                            <h3>VueJS</h3>
                        </div>
                        <div class="col-lg-6">
                            <div class="progress mt-2">
                                <div class="progress-bar blue-background" role="progressbar" style="width: 90%" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-lg-4 text-right">
                            <h3>ReactJS</h3>
                        </div>
                        <div class="col-lg-6">
                            <div class="progress mt-2">
                                <div class="progress-bar blue-background" role="progressbar" style="width: 65%" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-lg-4 text-right">
                            <h3>Objective-C</h3>
                        </div>
                        <div class="col-lg-6">
                            <div class="progress mt-2">
                                <div class="progress-bar blue-background" role="progressbar" style="width: 40%" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-lg-4 text-right">
                            <h3>React Native</h3>
                        </div>
                        <div class="col-lg-6">
                            <div class="progress mt-2">
                                <div class="progress-bar blue-background" role="progressbar" style="width: 35%" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div data-aos="fade-down" data-aos-duration="1500">
                    <div class="row mt-3">
                        <div class="col-lg-4 text-right">
                            <h3>Docker</h3>
                        </div>
                        <div class="col-lg-6">
                            <div class="progress mt-2">
                                <div class="progress-bar blue-background" role="progressbar" style="width: 90%" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-lg-4 text-right">
                            <h3>Firebase Web Tools</h3>
                        </div>
                        <div class="col-lg-6">
                            <div class="progress mt-2">
                                <div class="progress-bar blue-background" role="progressbar" style="width: 85%" aria-valuenow="85" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-lg-4 text-right">
                            <h3>GitLab CI Tools</h3>
                        </div>
                        <div class="col-lg-6">
                            <div class="progress mt-2">
                                <div class="progress-bar blue-background" role="progressbar" style="width: 90%" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-lg-4 text-right">
                            <h3>Digital Ocean</h3>
                        </div>
                        <div class="col-lg-6">
                            <div class="progress mt-2">
                                <div class="progress-bar blue-background" role="progressbar" style="width: 75%" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-lg-4 text-right">
                            <h3>Amazon Web Services</h3>
                        </div>
                        <div class="col-lg-6">
                            <div class="progress mt-2">
                                <div class="progress-bar blue-background" role="progressbar" style="width: 60%" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Expertise'
    }
</script>